import React from 'react';
import PropTypes from 'prop-types';
import Catalyst from '@Services/Catalyst';

import './Branding.scss';

function Branding({ companyPageUrl, companyLogoUrl }) {
  return (
    <div className="customer-branding">
      {/* customer logo is received in /user request */}
      <div className="logo-delimiter" />
      <a
        data-e2e="header-customer-logo"
        id="customer-logo"
        aria-label="Redirect to Customer Site"
        target="_blank"
        rel="noopener noreferrer"
        href={companyPageUrl || undefined}
        onClick={() => Catalyst.trackContentLinkClick('header:branding:logo', 'exit')}>
        <img src={companyLogoUrl} alt="Customer Logo" />
      </a>
    </div>
  );
}

export default Branding;

Branding.propTypes = {
  companyPageUrl: PropTypes.string,
  companyLogoUrl: PropTypes.string,
};
